__turbopack_context__.v({
  "dark": "IdVcHq_dark",
  "light": "IdVcHq_light",
});
